import React from 'react';
import { SummaryType } from '@ls/grouping-service';
import { useDispatch, useSelector } from 'react-redux';
import { DELETE_DEFINITION } from './actions';
import CalcType from 'state/Constants/CalcType';
import SelectionState from 'state/selections/SelectionState';
import {
  selectDefinitions,
  selectFetchingGridData,
  selectTraceAnalyticOptions,
  selectTracePeriodOptions,
} from 'state/traceAnalytics/selectors';

export const useColumnDefs = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
  const fetchingAbsData = useSelector(selectFetchingGridData(SummaryType.ABSOLUTE));
  const fetchingRelData = useSelector(selectFetchingGridData(SummaryType.RELATIVE));
  const traceAnalyticOptions = useSelector(selectTraceAnalyticOptions);
  const tracePeriodOptions = useSelector(selectTracePeriodOptions);
  const dispatch = useDispatch();
  return React.useMemo(() => {
    return definitions.reduce((columnDefs, definition) => {
      const {calcType, key} = definition;
      const traceAnalyticLabel = definition.findTraceAnalyticLabel(traceAnalyticOptions);
      const tracePeriodLabel = definition.findTracePeriodLabel(tracePeriodOptions);
      const columnDef = {
        field: key,
        colId: key,
        X_onDelete: () => dispatch({ type: DELETE_DEFINITION, payload: definition }),
      };
      switch (calcType) {
        case CalcType.Account:
          columnDef.headerName = `Acct Trace ${tracePeriodLabel}D\n${traceAnalyticLabel}`;
          columnDef.loading = fetchingAbsData;
          break;
        case CalcType.Relative:
          columnDef.headerName = `Rel Trace ${tracePeriodLabel}D\n${traceAnalyticLabel}`;
          columnDef.loading = fetchingRelData;
          break;
        case CalcType.Benchmark:
          columnDef.headerName = `Bench Trace ${tracePeriodLabel}D\n${traceAnalyticLabel}`;
          columnDef.loading = fetchingAbsData;
          break;
        default:
          throw Error('Unknown calc type: ' + calcType);
      }
      columnDefs.push(columnDef);
      return columnDefs;
    }, []);
  }, [definitions, dispatch, fetchingRelData, fetchingAbsData, traceAnalyticOptions, tracePeriodOptions]);
}